module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Sedona and Oak Creek Canyon")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-no",
    attrs: {
      "id": "C1"
    }
  }, [_c('i', [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "title-head1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDONA")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EASONS")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRING")]), _vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACH")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSSOM")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME AT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANYON")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESORT")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODGE")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v(". 1958.")]), _vm._v(" Apples and peaches were two crops of prime importance in Sedona and Oak Creek Canyon. The fruit was sold in the surrounding towns of Flagstaff and Jerome and sometimes Phoenix. The spring temperatures in the area average a high of 72 and a low of 45, and many travel sites suggest that the best time to visit Sedona is during the months of March, April, or May. (Bob Petley Studios, Phoenix, Arizona.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMER")]), _vm._v("—O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANYON IS A")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDERFUL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACE FOR")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISHING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNTING")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v(". 1951.")]), _vm._v(" Fishing and hunting in Oak Creek has declined with the increase in population and number of visitors, but other outdoor sports such as hiking, trail biking, and driving off-road vehicles have increased. The average high temperature during the summer is 97, but 100 degrees is not unusual, and most summer nights average a pleasant 66 degrees. (Union Oil Company, Natural Scenes of the West, No. 92.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMER")]), _vm._v("—O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANYON")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v(". 1966.")]), _vm._v(" The busiest time in Oak Creek Canyon is mid-summer, when most of Arizona is sweltering. Camping is very popular and requires advanced planning. The swimming holes and Slide Rock are crowded, but there are plenty of places for wading or splashing, hiking, or relaxing. (Bradshaw’s Color Studios.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL")]), _vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ED")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APLE AND")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDEN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SPENS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DD TO THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCHANTING")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLORS OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANYON")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("C")])]), _vm._v(". 1958.")]), _vm._v(" September in Sedona often is a slightly cooler extension of summer, but in October, the weather begins cooling and the leaves begin to change colors. Temperatures range from highs of 74 to lows of 49. (Bob Bradshaw Photo Shop, Sedona, Arizona.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INTER")]), _vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTLETOE OVER")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHEDRAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCK")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v(". 1965.")]), _vm._v(" When it snows, the red rock formations appear as giant frosted cakes. The town of Sedona averages about 9 to 11 inches of snow each year in most areas, which usually melts the next day. The higher elevations in Oak Creek Canyon receive more snow in the areas closer to Flagstaff. (Roben Company, Sedona, Arizona; photograph by Rollie F. Houck.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INTER")]), _vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIDE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCK")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(", O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANYON")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v(". 1966.")]), _vm._v(" The summer crowds have gone from this popular natural waterslide in Slide Rock State Park, and the temperatures average 58 during the day and 33 at night. Oak Creek continues to flow year-round, and the Visitors Center remains open. (Bradshaw Color Studios, Sedona, Arizona.)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6c9128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 81
// module chunks = 0